




















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class ListSorter extends Vue {
    @Prop() private ids!: number[];

    private hash: string = Math.random().toString();
    private dragElement!: HTMLElement;
    private compareElements!: HTMLElement[];
    private isChanged: boolean = false;

    private hashId(id: number) {
        return this.hash + "_" + id;
    }

    private unhashId(hashedId: string): number {
        return Number(hashedId.replace(this.hash + "_", ""));
    }

    private onDragStart(id: number): void {
        // todo ドラッグ対象のDOMをコピーして半透明でクローンし手動かす処理を追加！

        this.dragElement = document.getElementById(this.hashId(id)) as HTMLElement;
        this.compareElements = this.ids.filter(v => v != id).map(v => document.getElementById(this.hashId(v))) as HTMLElement[];
        this.isChanged = false;
        this.dragElement.style.pointerEvents = "none";
        (<HTMLElement>this.dragElement.querySelector(".list-inner")).classList.add("is-selected");
        (<HTMLElement>this.dragElement.parentNode).classList.add("is-move-list");
        document.addEventListener('mousemove', this.onDragMoveCallback);
        document.addEventListener('mouseup', this.onDragEndCallback);
    }

    private onDragMoveCallback = (e: MouseEvent) => this.onDragMove(e);

    private onDragMove(e: MouseEvent) {
        const sortList: { id: number, y: number }[] = this.compareElements.map((v) => {
            const id = this.unhashId(v.id);
            const rect = v.getBoundingClientRect();
            return {id: id, y: rect.top + scrollY + rect.height / 2};
        });
        sortList.push({id: this.unhashId(this.dragElement.id), y: e.pageY});

        const sortedIds: number[] = sortList.sort(((a, b) => a.y > b.y ? 1 : a.y < b.y ? -1 : 0)).map(v => v.id);
        const isChange: boolean = this.ids.filter((v, i) => v != sortedIds[i]).length > 0;
        if (isChange) {
            this.$emit("change", sortedIds);
            this.isChanged = true;
        }
    };

    private onDragEndCallback = (e: MouseEvent) => this.onDragEnd(e);

    private onDragEnd(e: MouseEvent) {
        this.dragElement.style.pointerEvents = "auto";
        (<HTMLElement>this.dragElement.querySelector(".list-inner")).classList.remove("is-selected");
        (<HTMLElement>this.dragElement.parentNode).classList.remove("is-move-list");
        document.removeEventListener('mousemove', this.onDragMoveCallback);
        document.removeEventListener('mouseup', this.onDragEndCallback);
        if (this.isChanged) {
            this.$emit("end");
        }
    }

}
